/**
 * @file bookingBreadcrumb.component.tsx
 * @path apps/website/src/features/booking/components/layout/bookingBreadcrumb.component.tsx
 * @description Booking page breadcrumb navigation.
 */

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@sirbastians/ui";
import { NAV_LINKS } from "@/config";

export const BookingBreadcrumb = () => (
  <Breadcrumb className="mb-6">
    <BreadcrumbList>
      <BreadcrumbItem>
        <BreadcrumbLink href={NAV_LINKS.home.path}>Home</BreadcrumbLink>
      </BreadcrumbItem>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbLink href={NAV_LINKS.experiences.path}>
          Experiences
        </BreadcrumbLink>
      </BreadcrumbItem>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>Booking</BreadcrumbPage>
      </BreadcrumbItem>
    </BreadcrumbList>
  </Breadcrumb>
);